module.exports = __webpack_public_path__ + "img/uniritter.470d5700.svg";